const genderConst = {
  man: 1,
  woman: 2
}

export default {
  data: function () {
    return {
      genderConst
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/GenderMixin.js